<template>
    <div class="wrap-back-top" :class="type">
        <div class="back-top" v-if="imageArr.length > 0">
            <div class="box-back-top">
                <div class="img-back-top" v-for="(data,index) in parImageArr('fir')"
                     :style="`background-image : url('${data.url}')`">
                </div>
            </div>
            <div class="box-back-top">
                <div class="img-back-top" v-for="(data,index) in parImageArr('sec')"
                     :style="`background-image : url('${data.url}')`">
                </div>
            </div>
            <div class="box-back-top">
                <div class="img-back-top" v-for="(data,index) in parImageArr('thi')"
                     :style="`background-image : url('${data.url}')`">
                </div>
            </div>
            <div class="box-back-top">
                <div class="img-back-top" v-for="(data,index) in parImageArr('fou')"
                     :style="`background-image : url('${data.url}')`">
                </div>
            </div>
            <div class="box-back-top">
                <div class="img-back-top" v-for="(data,index) in parImageArr('fiv')"
                     :style="`background-image : url('${data.url}')`">
                </div>
            </div>
            <div class="box-back-top">
                <div class="img-back-top" v-for="(data,index) in parImageArr('six')"
                     :style="`background-image : url('${data.url}')`">
                </div>
            </div>
            <div class="box-back-top">
                <div class="img-back-top" v-for="(data,index) in parImageArr('sev')"
                     :style="`background-image : url('${data.url}')`">
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import util from "@/mixins/util";

export default {
    name: "BackgroundComponent",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        type: {
            type: String,
            default: () => '',
        },

    },
    data() {
        return {
            imageArr: [],

        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.getImage();
    },
    mounted() {
    },
    beforeUnmount() {
    },
    unmounted() {
    },
    computed: {
    },
    methods: {
        parImageArr(data) {
            if (data === 'fir') {
                return this.imageArr.slice(0, 2);
            }
            if (data === 'sec') {
                return this.imageArr.slice(2, 5);
            }
            if (data === 'thi') {
                return this.imageArr.slice(5, 10);
            }
            if (data === 'fou') {
                return this.imageArr.slice(10, 15);
            }
            if (data === 'fiv') {
                return this.imageArr.slice(15, 20);
            }
            if (data === 'six') {
                return this.imageArr.slice(20, 23);
            }
            if (data === 'sev') {
                return this.imageArr.slice(23, 25);
            }

        },
        getImage() {
            let params = {};
            try {
                this.$api.$main.getMain(params).then(res => {
                    if (res.code === 1) {
                        if (!util.isEmpty(res.result.list)) {
                            this.imageArr = res.result.list;
                        }
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
    }
}
</script>

<style scoped>

</style>
